import { render, staticRenderFns } from "./CollectHistory.vue?vue&type=template&id=5b93b72b"
import script from "./CollectHistory.vue?vue&type=script&lang=js"
export * from "./CollectHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports